/** === COMPANY THEME (CI) === */
export const theme = {
  // Base
  bg: "#FFFFFF",
  cardBg: "#F4F4F4",
  border: "#A1A7AE",
  text: "#000000",
  muted: "#4D5056",
  accent: "#3D61AA",

  // Primary brand
  primary: "#F7675E",
  primarySoft: "#FEF0EF",
  primaryBorder: "#F7675E",

  // Secondary
  secondary: "#2C8F92",
  highlight: "#62C7EF",

  // Disabled
  disabled: "#A1A7AE",

  // Legacy compat (used by existing Cloud charts)
  successSoft: "#F4F4F4",
  successBorder: "#A1A7AE",

  // Charts
  bar: "#F7675E",
  radarFillOpacity: 0.25,
} as const;

/** SEAL level color mapping */
export const sealColors: Record<number, string> = {
  0: "#F7675E",  // Coral Red — no sovereignty
  1: "#E8A04C",  // Orange — jurisdictional
  2: "#D4C84A",  // Yellow — data sovereignty
  3: "#6BB89C",  // Light Teal — digital resilience
  4: "#2C8F92",  // Teal — full sovereignty
};

/** Provider-spezifische Farben (Cloud comparison) */
export const providerColors: Record<string, string> = {
  AWS: "#FF9900",
  "AWS ESC": "#FF9900",
  "AWS Commercial": "#FFB84D",
  Microsoft: "#F25022",
  DELOS: "#F25022",
  "Azure Commercial": "#FF7B5C",
  Google: "#0F9D58",
  StackIT: "#000000",
  Plusserver: "#FFD700",
  IBM: "#052FAD",
  OVH: "#5C2D91",
  IONOS: "#7D7D7D",
};

/** Inline Styles mit CI */
export const commonStyles = {
  pad: { padding: "12px" } as React.CSSProperties,
  card: { 
    border: `1px solid ${theme.border}`, 
    borderRadius: 3, 
    padding: "12px", 
    background: theme.cardBg 
  } as React.CSSProperties,
  hstack: { 
    display: "flex", 
    gap: 8, 
    alignItems: "center" 
  } as React.CSSProperties,
  button: { 
    border: `1px solid ${theme.border}`, 
    borderRadius: 3, 
    padding: "6px 10px", 
    background: "#fff", 
    cursor: "pointer", 
    color: theme.text 
  } as React.CSSProperties,
};
